module.exports = __webpack_public_path__ + "img/loading.57136a7e.gif";